export default __webpack_public_path__ + "static/media/campus (1).ae26ec8f.jpg";